import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { AppScope } from '../appScope.types';
import { StashedAppScope } from './StashedAppScope';

/** ModalHandler renders outside the route's provider: the opener's `ui.appScope` stash. */
export function PortaledModalAppScope({ children }: { children: ReactNode }) {
  const stashed = useSelector(
    (state: { ui: { appScope: AppScope | null } }) => state.ui.appScope
  );
  return <StashedAppScope stashed={stashed}>{children}</StashedAppScope>;
}
